
//Libraries
import { defineComponent, onMounted, ref } from "vue";

//Types
import type { FeaturedUserType } from "../../shared/types/featured-user-type";

export default defineComponent({
  name: "FeaturedUsers",
  setup() {
    //Data

    const isLoading = ref<boolean>(true);
    
    const users = ref<FeaturedUserType[]>([]);

    //Methods

    const getData = async (): Promise<any> => {
      return true;
    };

    //Lifecycle Hooks

    onMounted(() => {
      getData().then(() => {
        users.value = [
          {
            id: "a",
            name: "Jehieli Tamayo",
            points: 150,
            place: "Motul - Yucatán",
          },
          {
            id: "a",
            name: "Didier Balam",
            points: 150,
            place: "Motul - Yucatán",
          },
          {
            id: "a",
            name: "Jehieli Tamayo",
            points: 150,
            place: "Motul - Yucatán",
          },
          {
            id: "a",
            name: "Didier Balam",
            points: 150,
            place: "Motul - Yucatán",
          },
          {
            id: "a",
            name: "Didier Balam",
            points: 150,
            place: "Motul - Yucatán",
          },
        ];
        setTimeout(() => {
          isLoading.value = false;
        }, 1000);
      });
    });

    return {
      //Data
      isLoading,
      users,
    };
  },
});
